<template>
  <div :class="['sikuGold',iphoneX?'iphoneX':'']">
    <c-nav></c-nav>
    <div :class="ptid==='1'?'container':'notLogo'">
      <div class="rule" @click="showRule"></div>
      <div class="desc a-text-12">
        <div v-if="isVIP">
          <div>亲爱的用户，您已领取过会员权益</div>
          <div>请前往高铁管家客户端查看！</div>
        </div>
        <div v-if="hasGotVIP">
          <div>
            恭喜您，成功免费领取
            <span class="yellow">1个月黄金</span>
          </div>
          <div>请前往高铁管家客户端查看！</div>
        </div>
      </div>
      <div class="getVip zoomIn" v-if="!hasGotVIP&&!isVIP" @click="getVIP"></div>
      <div class="checkPriority" v-if="hasGotVIP||isVIP" @click="checkPriority"></div>
      <div class="content a-text-11 a-lightblack">
        <div class="lineOne fx-row">
          <div class="birthGift fx-col fx-center fx-1">
            <div class="icon"></div>
            <div>29元生日礼物</div>
          </div>
          <div class="hotel fx-col fx-center fx-1">
            <div class="icon"></div>
            <div>酒店专享9.4折</div>
          </div>
          <div class="speed fx-col fx-center fx-1">
            <div class="icon"></div>
            <div>抢票提速1.5倍</div>
          </div>
        </div>
        <div class="lineTwo fx-row">
          <div class="tisubao fx-col fx-center fx-1">
            <div class="icon"></div>
            <div>提速宝10个</div>
          </div>
          <div class="delaybao fx-col fx-center fx-1">
            <div class="icon"></div>
            <div>延误宝2个</div>
          </div>
          <div class="assist fx-col fx-center fx-1">
            <div class="icon"></div>
            <div>最佳主助攻手3个</div>
          </div>
        </div>
      </div>
      <div class="bottomDesc a-text-12" @click="checkPriority">了解更多会员权益></div>

      <!-- <div class="renwu"></div> -->
    </div>
    <rule :isShowRule="isShowRule" @close="close"></rule>
  </div>
</template>
<script>
import auth from "@/request/auth.js";
import { handleException } from "@/request/helpers.js";
import localStorage from "@/utils/localStorage.js";

import { mapActions, mapState, mapMutations } from "vuex";

import rule from "./components/rule";
import downloadApp from '../../Helper/download-app.js';

export default {
  data() {
    return {
      isShowRule: false,
      iphoneX: false,
      ptid: null
    };
  },
  computed: {
    ...mapState("vipCard/sikuGold", ["hasGotVIP", "isVIP"])
  },
  created() {
    this.iphoneX = this.isIphoneX();
    this.ptid = localStorage.get("ptid");
  },
  methods: {
    ...mapActions("vipCard/sikuGold", ["creatGlodVIP"]),
    ...mapMutations("vipCard/sikuGold", ["updateVIPState", "updateHasGotVIP"]),
    isIphoneX() {
      return (
        /iphone/gi.test(navigator.userAgent) &&
        (screen.height == 812 && screen.width == 375)
      );
    },
    getVIP() {
      auth
        .ensure({
          method: "replace",
          callback: this.getVIP
        })
        .then(() => {
          this.creatGlodVIP()
            .then(res => {
              let code = parseInt(res.res.bd.data.code);
              if (code === 0) {
                this.updateHasGotVIP(true);
              } else if (code === 3) {
                this.updateVIPState(true);
                return this.$notify({
                  type: "info",
                  message: "您已经领取过啦",
                  showClose: true
                });
              }
            })
            .catch(err => {
              handleException.call(this, err, true);
            });
        })
        .catch(err => {
          handleException.call(this, err, true);
        });
    },
    checkPriority() {
      downloadApp();
    },
    showRule() {
      this.isShowRule = true;
    },
    close() {
      this.isShowRule = false;
    }
  },
  components: {
    rule
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/_vars.scss";
@import "./style/common.scss";
.yellow {
  color: #fee273;
}
.sikuGold {
  width: 100%;
  height: 100%;
  background-color: #022887;
  .container,
  .notLogo {
    width: 375 * $px;
    @include bg("bg@3x.png");
    height: 603 * $px;
    position: relative;
    .rule {
      position: absolute;
      right: 1 * $px;
      top: 1 * $px;
      width: 60 * $px;
      height: 60 * $px;
      @include bg("rule.png");
    }
    .desc {
      position: absolute;
      top: 182 * $px;
      width: 100%;
      color: #acbdff;
      div {
        text-align: center;
      }
    }
    .checkPriority {
      position: absolute;
      top: 232 * $px;
      left: 50%;
      transform: translateX(-50%);
      width: 270 * $px;
      height: 46 * $px;
      @include bg("checkPriority@3x.png");
    }
    .getVip {
      position: absolute;
      top: 200 * $px;
      left: 50%;
      transform: translateX(-50%);
      width: 270 * $px;
      height: 54 * $px;
      @include bg("getVip@3x.png");
      &.zoomIn {
        animation: zoomIn 1s infinite;
        @keyframes zoomIn {
          0% {
            transform: translateX(-50%) scale(1);
          }
          50% {
            transform: translateX(-50%) scale(1.1);
          }
          100% {
            transform: translateX(-50%) scale(1);
          }
        }
      }
    }
    .content {
      position: absolute;
      top: 283 * $px;
      padding-top: 79 * $px;
      width: 375 * $px;
      height: 275 * $px;
      box-sizing: border-box;
      @include bg("box@3x.png");
      .icon {
        width: 55 * $px;
        height: 55 * $px;
        margin-bottom: 7 * $px;
      }
      .lineOne,
      .lineTwo {
        width: 340 * $px;
        margin: 0 auto;
        padding: 0 10 * $px;
        box-sizing: border-box;
        margin-bottom: 15 * $px;
      }
      .birthGift {
        .icon {
          @include bg("birthGift@3x.png");
        }
      }
      .hotel {
        .icon {
          @include bg("hotel@3x.png");
        }
      }
      .speed {
        .icon {
          @include bg("speed@3x.png");
        }
      }
      .tisubao {
        .icon {
          @include bg("tisubao@3x.png");
        }
      }
      .delaybao {
        .icon {
          @include bg("delaybao@3x.png");
        }
      }
      .assist {
        .icon {
          @include bg("assist@3x.png");
        }
      }
    }
    .bottomDesc {
      position: absolute;
      top: 572 * $px;
      left: 50%;
      transform: translateX(-50%);
      color: #acbdff;
    }
    .renwu {
      position: absolute;
      top: 255 * $px;
      right: 20 * $px;
      width: 65 * $px;
      height: 81 * $px;
      @include bg("renwu@3x.png");
    }
  }
  .notLogo {
    @include bg("bg_notLogo@3x.png");
  }
}
.iphoneX {
  .desc {
    top: 192 * $px !important;
  }
  .checkPriority {
    top: 252 * $px !important;
  }
  .content {
    top: 323 * $px !important;
  }
  .bottomDesc {
    top: 612 * $px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/vipCard/pages/sikuGold/checkPriority.vue